import http from "../httpService";
import moment from 'moment'

const apiEndpoint = "/report/dashboard";

export function getDashboardSummary({filter='today', date=moment().format('YYYY-MM-DD')}) {
    return http.get(apiEndpoint + '/summary/?filter=' + filter + '&date=' + date)
  }